import type { TFunction } from "i18next";
import { toCamelCase } from "@/lib/utils";

export function getDetailFieldLabel(
  labelKey: string | undefined,
  module: string | null,
  field: string,
  t: TFunction,
): string {
  if (labelKey != null) return t(labelKey);
  if (module != null) return t(`${toCamelCase(module)}.fields.${field}`);
  return "";
}
